<div class="auth-layout">
    <!-- Overlay de carga durante navegación -->
    <div *ngIf="isNavigating" class="loading-overlay">
        <mat-spinner diameter="48" color="primary"></mat-spinner>
        <p class="loading-text">Ingresando al sistema...</p>
    </div>

    <div class="auth-view auth-view-initial" [class.active]="currentView === 'initial'">
        <div class="split-container">
            <!-- Panel izquierdo: Branding -->
            <div class="split-panel split-panel-left split-panel-branding">
                <div class="branding-content">
                    <div class="branding-logo">
                        <img src="assets/image/toby.png" alt="Epago Logo" />
                    </div>
                    <h1 class="branding-title">Bienvenido al backoffice de ePago</h1>
                    <p class="branding-subtitle">Para continuar, seleccione su tipo de usuario en el siguiente panel.
                    </p>
                </div>
            </div>

            <!-- Panel derecho: Selección -->
            <div class="split-panel split-panel-right">
                <div class="panel-content">
                    <div class="initial-content">
                        <h2 class="selection-title">Inicio sesión</h2>

                        <div class="initial-actions">
                            <button type="button" class="auth-button-primary" (click)="selectSSO()">
                                <svg class="button-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    stroke-width="2">
                                    <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
                                    <polyline points="17 21 17 13 7 13 7 21"></polyline>
                                    <polyline points="7 3 7 8 15 8"></polyline>
                                </svg>
                                <span>Acceder con cuenta corporativa</span>
                                <small>SSO / Active Directory</small>
                            </button>

                            <div class="initial-separator">
                                <span>o</span>
                            </div>

                            <button type="button" class="auth-button-secondary" (click)="selectExternal()">
                                Acceder como comercio externo
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Vista SSO: Split con info a la izquierda -->
    <div class="auth-view auth-view-sso" [class.active]="currentView === 'sso'">
        <div class="split-container">
            <!-- Panel izquierdo: Formulario/info SSO -->
            <div class="split-panel split-panel-left">
                <div class="panel-content">
                    <div class="sso-info">
                        <div class="sso-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
                                <polyline points="17 21 17 13 7 13 7 21"></polyline>
                                <polyline points="7 3 7 8 15 8"></polyline>
                            </svg>
                        </div>
                        <h2 class="sso-title">Redireccionando...</h2>
                        <p class="sso-message">Serás redirigido a tu proveedor corporativo para completar el inicio de
                            sesión.</p>
                        <div class="sso-loading">
                            <mat-spinner diameter="32" color="primary"></mat-spinner>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Panel derecho: Branding -->
            <div class="split-panel split-panel-right split-panel-branding">
                <div class="branding-content">
                    <div class="branding-logo">
                        <img src="assets/image/toby.png" alt="Epago Logo" />
                    </div>
                    <h1 class="branding-title">Epago Backoffice</h1>
                    <p class="branding-subtitle">Acceso seguro mediante SSO</p>
                    <div class="branding-features">
                        <div class="feature-item">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                <polyline points="22 4 12 14.01 9 11.01"></polyline>
                            </svg>
                            <span>Autenticación segura</span>
                        </div>
                        <div class="feature-item">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                            </svg>
                            <span>Gestión centralizada</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="auth-view auth-view-external" [class.active]="currentView === 'external'">
        <div class="split-container">
            <!-- Panel izquierdo: Branding -->
            <div class="split-panel split-panel-left split-panel-branding">
                <div class="branding-content">
                    <div class="branding-logo">
                        <img src="assets/image/toby.png" alt="Epago Logo" />
                    </div>
                    <h1 class="branding-title">Epago Backoffice</h1>
                    <p class="branding-subtitle">Acceso para comercios externos</p>
                    <div class="branding-features">
                        <div class="feature-item">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                                <circle cx="8.5" cy="7" r="4"></circle>
                                <polyline points="17 11 19 13 23 9"></polyline>
                            </svg>
                            <span>Gestión de usuarios</span>
                        </div>
                        <div class="feature-item">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                            </svg>
                            <span>Acceso protegido</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Panel derecho: Formulario -->
            <div class="split-panel split-panel-right">
                <div class="panel-content">
                    <button class="back-button" (click)="goBack()" type="button">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <polyline points="15 18 9 12 15 6"></polyline>
                        </svg>
                        Volver
                    </button>

                    <div class="form-container">
                        <h2 class="form-title">Inicio sesión</h2>

                        <form [formGroup]="authExternalForm" class="login-form" (keyup.enter)="externalLogin()">
                            <input type="hidden" formControlName="space" />
                            <input type="hidden" formControlName="domain" />

                            <mat-form-field appearance="outline" class="form-field">
                                <mat-label>Usuario</mat-label>
                                <input matInput formControlName="userName" placeholder="Ingresa tu usuario" />
                                <mat-icon matSuffix>person</mat-icon>
                                <mat-error *ngIf="userNameControl?.hasError('required')">
                                    El usuario es requerido
                                </mat-error>
                                <mat-error *ngIf="userNameControl?.hasError('minlength')">
                                    El usuario debe tener al menos 3 caracteres
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="form-field">
                                <mat-label>Contraseña</mat-label>
                                <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password"
                                    placeholder="Ingresa tu contraseña" autocomplete="current-password" />
                                <button mat-icon-button matSuffix type="button"
                                    [attr.aria-label]="hidePassword ? 'Mostrar contraseña' : 'Ocultar contraseña'"
                                    (click)="hidePassword = !hidePassword">
                                    <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                                </button>
                                <mat-error *ngIf="passwordControl?.hasError('required')">
                                    La contraseña es requerida
                                </mat-error>
                                <mat-error *ngIf="passwordControl?.hasError('minlength')">
                                    La contraseña debe tener al menos 6 caracteres
                                </mat-error>
                            </mat-form-field>

                            <div class="error-message" *ngIf="messageError">
                                <mat-icon>error</mat-icon>
                                <span>{{ messageError }}</span>
                            </div>

                            <button type="button" class="form-submit-button app-cta-button app-cta-button--block" mat-raised-button color="primary"
                                (click)="externalLogin()" [disabled]="!isFormValid || isLoading">
                                <mat-icon *ngIf="!isLoading">login</mat-icon>
                                <mat-spinner *ngIf="isLoading" diameter="18"></mat-spinner>
                                {{ isLoading ? 'Entrando…' : 'Acceder' }}
                            </button>

                            <button type="button" class="forgot-password-button" mat-button (click)="onForgotPassword()"
                                [disabled]="isLoading">
                                <mat-icon>help</mat-icon>
                                Olvidé mi contraseña
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="auth-view auth-view-forgot-password" [class.active]="currentView === 'forgot-password'">
        <div class="split-container">
            <!-- Panel izquierdo: Branding -->
            <div class="split-panel split-panel-left split-panel-branding">
                <div class="branding-content">
                    <div class="branding-logo">
                        <img src="assets/image/toby.png" alt="Epago Logo" />
                    </div>
                    <h1 class="branding-title">Epago Backoffice</h1>
                    <p class="branding-subtitle">Recupera tu acceso</p>
                    <div class="branding-features">
                        <div class="feature-item">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z">
                                </path>
                                <polyline points="22,6 12,13 2,6"></polyline>
                            </svg>
                            <span>Recuperación por email</span>
                        </div>
                        <div class="feature-item">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                <polyline points="22 4 12 14.01 9 11.01"></polyline>
                            </svg>
                            <span>Proceso seguro</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Panel derecho: Formulario -->
            <div class="split-panel split-panel-right">
                <div class="panel-content">
                    <button class="back-button" (click)="goBack()" type="button">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <polyline points="15 18 9 12 15 6"></polyline>
                        </svg>
                        Volver
                    </button>

                    <div class="form-container">
                        <h2 class="form-title">Recuperar contraseña</h2>
                        <p class="form-subtitle">Ingresa tu correo electrónico para recibir el enlace de recuperación
                        </p>

                        <div class="info-banner">
                            <mat-icon>info</mat-icon>
                            <p>Ingresa tu correo electrónico registrado, dale click en "enviar" y revisa tu buzón de
                                entrada o SPAM para cambiar tu nueva clave.</p>
                        </div>

                        <form [formGroup]="forgotPasswordForm" class="login-form"
                            (keyup.enter)="submitForgotPassword()">
                            <mat-form-field appearance="outline" class="form-field">
                                <mat-label>Nombre de usuario o correo electrónico</mat-label>
                                <input matInput formControlName="email" placeholder="Ingresa tu correo electrónico"
                                    type="email" />
                                <mat-icon matSuffix>email</mat-icon>
                                <mat-error *ngIf="emailControl?.hasError('required')">
                                    El correo electrónico es requerido
                                </mat-error>
                                <mat-error *ngIf="emailControl?.hasError('email')">
                                    Ingresa un correo electrónico válido
                                </mat-error>
                            </mat-form-field>

                            <div class="error-message"
                                *ngIf="forgotPasswordMessage && !forgotPasswordMessage.includes('enviado')">
                                <mat-icon>error</mat-icon>
                                <span>{{ forgotPasswordMessage }}</span>
                            </div>

                            <div class="success-message"
                                *ngIf="forgotPasswordMessage && forgotPasswordMessage.includes('enviado')">
                                <mat-icon>check_circle</mat-icon>
                                <span>{{ forgotPasswordMessage }}</span>
                            </div>

                            <button type="button" class="form-submit-button app-cta-button app-cta-button--block" mat-raised-button color="primary"
                                (click)="submitForgotPassword()"
                                [disabled]="!isForgotPasswordFormValid || isForgotPasswordLoading">
                                <mat-icon *ngIf="!isForgotPasswordLoading">send</mat-icon>
                                <mat-spinner *ngIf="isForgotPasswordLoading" diameter="18"></mat-spinner>
                                {{ isForgotPasswordLoading ? 'Enviando' : 'Enviar' }}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>